module.exports = __webpack_public_path__ + "media/images/admin/icons/send-fab9d9661d8d41abd207906755d8209e.svg";